<template>
  <div class="tab-content account-info-root">
    <div class="search-layout">
      <div class="item-wrap">
        <el-input
          placeholder="节假日名称"
          size="small"
          v-model="formIn.holidaysFestivalsName"
          @input="doQueryPlatformHolidaysFestivalsList"
        />
      </div>
      <div class="item-wrap long">
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="筛选日期-开始"
          end-placeholder="筛选日期-结束"
          size="small"
          @change="doQueryPlatformHolidaysFestivalsList"
        >
        </el-date-picker>
      </div>

      <div class="item-wrap op custom-child">
        <el-button size="small" type="primary" @click="hanldeNewItem"
          >新增</el-button
        >
      </div>
    </div>
    <div style="margin-top: 8px">
      <el-table :data="tableData">
        <el-table-column prop="holidaysFestivalsName" label="节假日名称">
        </el-table-column>
        <el-table-column prop="instructions" label="日期">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.holidaysFestivalsStartTime +
                "-" +
                scope.row.holidaysFestivalsEndTime
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="updateBy" label="更新人"> </el-table-column>
        <el-table-column prop="updateTime" label="更新时间"> </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <div>
              <el-button
                size="small"
                type="text"
                @click="handleEdit(scope.$index)"
                >修改</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="handleDelete(scope.$index)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <NewHolidyDlg
      ref="refNewHolidyDlg"
      @update="doQueryPlatformHolidaysFestivalsList"
    />
  </div>
</template>

<script>
import NewHolidyDlg from "../dialog/NewHolidyDlg.vue";
import _ from "lodash";
import dayjs from "dayjs";

import {
  queryPlatformHolidaysFestivalsList,
  delFestivalsById,
} from "@/api/platform/index.js";

export default {
  components: { NewHolidyDlg },
  props: {},
  data() {
    return {
      time: "",

      formIn: {
        holidaysFestivalsName: "",
        startTime: "",
        endTime: "",
      },
      /**

         */
      tableData: [],
    };
  },
  created() {
    this.doQueryPlatformHolidaysFestivalsList();
  },
  methods: {
    doQueryPlatformHolidaysFestivalsList() {
      const params = {};

      if (this.time) {
        this.formIn.startTime = dayjs(this.time[0]).format("YYYY-MM-DD");
        this.formIn.endTime = dayjs(this.time[1]).format("YYYY-MM-DD");
      }
      _.merge(params, this.formIn);

      queryPlatformHolidaysFestivalsList(params).then((data) => {
        if (data instanceof Array && data.length > 0) {
          this.tableData = data;
        } else {
          this.tableData = [];
        }
      });
    },
    hanldeNewItem() {
      this.$refs.refNewHolidyDlg.open();
    },
    handleEdit(index) {
      const item = this.tableData[index];

      this.$refs.refNewHolidyDlg.open(item);
    },
    handleDelete(index) {
      const item = this.tableData[index];
      this.$confirm("删除后不可恢复，是否确认?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delFestivalsById(item.id).then((res) => {
            if (res) {
              this.$message.success("删除成功");
              this.doQueryPlatformHolidaysFestivalsList();
            }
          });
        })
        .catch(() => {
          //
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/index.scss";
@import "@/views/salesControl/OperationsManag/style/index.scss";
.account-info-root {
  .add-layout {
  }
}
</style>
